async function handleFlexPortTrackingData(flexPortUrl) {
  try {
    const res = await fetch(flexPortUrl);
    const data = await res.json();
    if (data.message == "API call successful!") {
      // console.log(data.data);
      const htmlData = data.data;
      const regEx = /window\.__remixContext\s*=\s*({.*?});/s;
      const match = htmlData.match(regEx);
      if (match) {
        const result = JSON.parse(match[1]);
        return result;
      } else {
        console.log("Not found");
        return null;
      }
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}
